const Hero = () => {
  return (
    <>
    <div className="relative h-64">
      <picture>
        
        <source
          media="(min-width: 1024px)"
          srcSet="/hero/Dest.png"
          sizes="(min-width: 1500px) 1500px, 100vw"
        />
        
       
  <img
    className="w-full h-full object-cover mt-16"
    src="/hero/Dest.png"
    alt="Holidays"
  />
 
      </picture>
      {/* <div className="absolute inset-0 flex flex-col justify-end pb-10">
        <h1 className="text-4xl text-white font-bold md:px-20 lg:px-20 mx-5 md:text-5xl lg:text-5xl">Find your next stay</h1>
        <p className="text-2xl md:px-20 lg:px-20 text-white mx-5">
          Search low prices on hotels for your dream holiday...
        </p>
      </div> */}
    </div>
    </>
  );
};

export default Hero;